<!-- Main Navigation -->
<nav class="main-nav">
    <div class="nav-container">
        <!-- Logo Section -->
        <div class="nav-logo">
            <a routerLink="/">
                <img src="assets/images/logo/i2-logo.svg" alt="Industry Intelligence" class="h-11 w-auto" />
            </a>
        </div>

        <!-- Main Navigation Items -->
        <ul class="nav-list">
            <li class="nav-item" *ngFor="let menuItem of mainMenuItems" [attr.data-section]="menuItem.id">
                <button class="nav-button">
                    {{ menuItem.title }}
                    <svg class="nav-arrow" viewBox="0 0 16 16">
                        <path d="M8 12L2 6h12z" fill="currentColor"/>
                    </svg>
                </button>
                <div class="nav-dropdown">
                    <!-- Products Layout - Single Column -->
                    <div class="dropdown-grid products-grid" *ngIf="menuItem.id === 'products'">
                        <!-- Corporate Services Section -->
                        <div class="dropdown-section">
                            <h3 class="dropdown-category text-xs font-medium text-gray-500 uppercase tracking-wider mb-3">Corporate Services</h3>
                            <div class="dropdown-items">
                                <a [routerLink]="item.route" class="dropdown-item" *ngFor="let item of menuItem.sections[0].items">
                                    <i class="fas fa-{{ item.icon }}" [style.color]="item.iconColor || '#4a6baf'"></i>
                                    <div>
                                        <div class="flex items-center gap-2">
                                            <h4>{{ item.title }}</h4>
                                        </div>
                                        <p>{{ item.description }}</p>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <!-- Visual Separator -->
                        <div class="border-t border-gray-200 my-4"></div>

                        <!-- Subscription Services Section -->
                        <div class="dropdown-section">
                            <h3 class="dropdown-category text-xs font-medium text-gray-500 uppercase tracking-wider mb-3">Subscription Services</h3>
                            <div class="dropdown-items">
                                <a [routerLink]="item.route" class="dropdown-item" *ngFor="let item of menuItem.sections[1].items">
                                    <i class="fas fa-{{ item.icon }}" [style.color]="item.iconColor || '#4a6baf'"></i>
                                    <div>
                                        <div class="flex items-center gap-2">
                                            <h4>{{ item.title }}</h4>
                                        </div>
                                        <p>{{ item.description }}</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Solutions Layout - Two Columns -->
                    <div class="dropdown-grid solutions-grid" *ngIf="menuItem.id === 'solutions'">
                        <div class="dropdown-content">
                            <div class="dropdown-section" *ngFor="let section of menuItem.sections; let i = index">
                                <h3 class="dropdown-category">{{ section.title }}</h3>
                                <div class="dropdown-items-grid">
                                    <a [routerLink]="item.route" class="dropdown-item" *ngFor="let item of section.items">
                                        <i class="fas fa-{{ item.icon }}" [style.color]="item.iconColor || '#4a6baf'"></i>
                                        <div>
                                            <h4>{{ item.title }}</h4>
                                            <p>{{ item.description }}</p>
                                        </div>
                                    </a>
                                </div>
                                <!-- Add visual separator between sections -->
                                <div class="section-separator" *ngIf="i < menuItem.sections.length - 1"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Resources Layout - Two Columns -->
                    <div class="dropdown-grid resources-grid" *ngIf="menuItem.id === 'resources'">
                        <div class="dropdown-content">
                            <div class="dropdown-section" *ngFor="let section of menuItem.sections; let i = index">
                                <h3 class="dropdown-category">{{ section.title }}</h3>
                                <div class="dropdown-items-grid">
                                    <a [routerLink]="item.route" class="dropdown-item" *ngFor="let item of section.items">
                                        <i class="fas fa-{{ item.icon }}" [style.color]="item.iconColor || '#4a6baf'"></i>
                                        <div>
                                            <h4>{{ item.title }}</h4>
                                            <p>{{ item.description }}</p>
                                        </div>
                                    </a>
                                </div>
                                <!-- Add visual separator between sections -->
                                <div class="section-separator" *ngIf="i < menuItem.sections.length - 1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <!-- Right-aligned Actions -->
        <div class="nav-actions">
            <a routerLink="/demo" class="nav-link explore-demo">
                <i class="fas fa-play-circle mr-2"></i>
                Explore Demo
            </a>
            <a routerLink="/signin" class="nav-link sign-in">Sign in</a>
        </div>

        <button class="mobile-menu-button" (click)="toggleMenu()">
            <i class="fas" [class.fa-bars]="!isMenuOpen" [class.fa-times]="isMenuOpen"></i>
        </button>
    </div>
</nav>

<!-- Mobile Menu -->
<div class="mobile-menu" [class.is-open]="isMenuOpen">
    <div class="mobile-menu-header">
        <a class="mobile-menu-back" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            {{ currentLevel === 1 ? 'Close' : 'Back' }}
        </a>
        <button class="mobile-menu-close" (click)="closeMenu()">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <div class="mobile-menu-content">
        <!-- Level 1 Navigation -->
        <div class="mobile-items" *ngIf="currentLevel === 1">
            <a class="mobile-item" *ngFor="let item of mainMenuItems" (click)="navigateToSection(item.id)">
                <div class="mobile-item-content">
                    <span>{{ item.title }}</span>
                </div>
                <i class="fas fa-chevron-right mobile-item-chevron"></i>
            </a>
        </div>

        <!-- Level 2 Navigation -->
        <div class="mobile-sections" *ngIf="currentLevel === 2 && getCurrentSection()">
            <div class="mobile-section" *ngFor="let section of getCurrentSection()?.sections || []">
                <h3 class="mobile-section-title">{{ section.title }}</h3>
                <div class="mobile-items">
                    <a [routerLink]="item.route" class="mobile-item" *ngFor="let item of section.items" (click)="closeMenu()">
                        <div class="mobile-item-content">
                            <i class="fas fa-{{ item.icon }} mobile-item-icon" [style.color]="item.iconColor || '#4a6baf'"></i>
                            <div class="mobile-item-text">
                                <span class="mobile-item-title">{{ item.title }}</span>
                                <span class="mobile-item-description">{{ item.description }}</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mobile-actions">
            <a routerLink="/demo" class="mobile-button primary">Explore Demo</a>
            <a routerLink="/signin" class="mobile-button secondary">Sign in</a>
        </div>
    </div>
</div>